export default {
  methods: {
    iconFromFilename (filename) {
      const ext = filename ? filename.split('.').pop().toLowerCase() : null
      let icon = 'Other'
      switch (ext) {
        case 'doc':
        case 'docx':
          icon = 'Word'
          break
        case 'pdf':
          icon = 'PDF'
          break
        case 'exe':
          icon = 'Software'
          break
        case 'mp4':
          icon = 'Video'
          break
      }

      return icon + '.webp'
    }
  }
}
